import { useEffect, useState } from 'react';

/**
 * Whether the server would still accept taking that answer back.
 *
 * The deadline comes from the server, and the button disappears when it passes
 * rather than staying and failing: offering an undo the server has already
 * closed is worse than not offering one at all.
 */
const isStillOpen = (expiresAt: string | null | undefined): boolean => {
  if (!expiresAt) return false;
  const deadline = Date.parse(expiresAt);
  return Number.isFinite(deadline) && deadline > Date.now();
};

export const useUndoWindow = (expiresAt: string | null | undefined): boolean => {
  const [open, setOpen] = useState(() => isStillOpen(expiresAt));

  useEffect(() => {
    const stillOpen = isStillOpen(expiresAt);
    setOpen(stillOpen);
    if (!stillOpen || !expiresAt) return;

    const timer = window.setTimeout(
      () => setOpen(false),
      Math.max(0, Date.parse(expiresAt) - Date.now())
    );
    return () => window.clearTimeout(timer);
  }, [expiresAt]);

  return open;
};
